<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="m-0 p-3 background-primary-blue height-70px shadow z-max d-flex justify-content-between align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="text-center color-white p-4 fs-lg">Settings</div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 gap-3 overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div>
            <div class="h5">Notifications</div>
            <div class="mb-2 card rounded-3 p-3">
                <div class="fw-bold">Animal notifications</div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.OUT_OF_FARM] !== false"
                        (change)="togglePreferences(AlertStatus.OUT_OF_FARM)"
                        [disabled]="userStore.loading()"
                        label="Out of farm"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.OUT_OF_PADDOCK] !== false"
                        (change)="togglePreferences(AlertStatus.OUT_OF_PADDOCK)"
                        [disabled]="userStore.loading()"
                        label="Out of paddock"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.STOPPED_MOVING] !== false"
                        (change)="togglePreferences(AlertStatus.STOPPED_MOVING)"
                        [disabled]="userStore.loading()"
                        label="Stopped moving"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.ABNORMALLY_LOW_ACTIVITY] !== false"
                        (change)="togglePreferences(AlertStatus.ABNORMALLY_LOW_ACTIVITY)"
                        [disabled]="userStore.loading()"
                        label="Abnormally low activity"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.ABNORMALLY_HIGH_ACTIVITY] !== false"
                        (change)="togglePreferences(AlertStatus.ABNORMALLY_HIGH_ACTIVITY)"
                        [disabled]="userStore.loading()"
                        label="Abnormally high activity"/>
                </div>
            </div>
            <div class="mb-2 card rounded-3 p-3">
                <div class="fw-bold">Water point notifications</div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.HIGH_ALERT] !== false"
                        (change)="togglePreferences(AlertStatus.HIGH_ALERT)"
                        [disabled]="userStore.loading()"
                        label="Very high alert"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.HIGH_WARNING] !== false"
                        (change)="togglePreferences(AlertStatus.HIGH_WARNING)"
                        [disabled]="userStore.loading()"
                        label="High alert"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.LOW_WARNING] !== false"
                        (change)="togglePreferences(AlertStatus.LOW_WARNING)"
                        [disabled]="userStore.loading()"
                        label="Low alert"/>
                </div>
                <div class="m-1">
                    <app-switch
                        [checked]="userStore.user()?.preferences?.notifications?.[AlertStatus.LOW_ALERT] !== false"
                        (change)="togglePreferences(AlertStatus.LOW_ALERT)"
                        [disabled]="userStore.loading()"
                        label="Very low alert"/>
                </div>
            </div>
        </div>

        <div>
            <div class="h5">Map</div>
            <div class="mb-2 card rounded-3 p-3">
                <div class="dropdown">
                    <button aria-controls="locationAgeFilterDropdown"
                            aria-expanded="false"
                            class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                            data-bs-target="#locationAgeFilterDropdown"
                            data-bs-toggle="collapse">
                        {{ mapStore.locationAgeFilterPeriod() | toCapitalizedText }}
                    </button>
                    <div class="collapse w-100 dropdown-options card" id="locationAgeFilterDropdown">
                        @for (period of locationAgeFilterOptions; track period) {
                            <div (click)="selectLocationAgeFilterPeriod(period)"
                                data-bs-target="#locationAgeFilterDropdown"
                                data-bs-toggle="collapse"
                                class="btn card dropdown-option">{{ period | toCapitalizedText }}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        @if (userStore.isAdmin()) {
            <div>
                <div class="h5">Admin</div>
                <div class="mb-2 card rounded-3 p-3">
                    <div class="m-1">
                        <app-switch
                            [checked]="skipAnomalousLocations()"
                            (change)="toggleSkipAnomalousLocations()"
                            [disabled]="updatingFarm()"
                            label="Skip anomalous locations"/>
                    </div>
                    <div class="m-1 d-flex justify-content-start align-items-center">
                        <app-numeric-stepper
                            [value]="maxZoomLevel()"
                            [decrementEnabled]="maxZoomLevel() > 15"
                            [incrementEnabled]="maxZoomLevel() < 21"
                            (change)="setMaxZooMLevel($event)"
                            [disabled]="updatingFarm()"/>
                        <span class="ps-3">Maximum zoom level</span>
                    </div>
                </div>
            </div>
        }

        <div>
            <div class="h5">Session</div>
            <div class="mb-2 card rounded-3 p-3">
                <div class="mb-2">
                    <span class="fw-bold">Currently logged in as:</span>
                    {{ userStore.user()?.uid }}
                </div>
                <div class="mb-2">
                    <span class="fw-bold">Active user agent:</span>
                    {{ userAgentId() }}
                </div>
                <div class="mb-2">
                    <span class="fw-bold">Current farm name:</span>
                    {{ farmStore.farm()?.name }}
                </div>
                <div class="mb-2">
                    <span class="fw-bold">Current farm id:</span>
                    {{ farmStore.farm()?.id }}
                </div>
                <div class="mb-2">
                    <span class="fw-bold">App version:</span>
                    {{ appVersion }}
                </div>
                <div class="mb-2">
                    <app-generic-button
                        (click)="logout()"
                        description="Logout"
                        [alwaysShowText]="true"
                        [buttonText]="'Logout'"
                        [primaryIcon]="'fa-solid fa-right-to-bracket fa-xl'"></app-generic-button>
                </div>
                <div class="mb-2">
                    <app-generic-button
                        (click)="clearLocalDB()"
                        description="Clear local database"
                        [alwaysShowText]="true"
                        [buttonText]="'Clear local database'"
                        [primaryIcon]="'fa-solid fa-trash-can fa-xl'"></app-generic-button>
                </div>
              <div class="mb-2">
                <app-generic-button
                  (click)="clearDLQ()"
                  description="Clear DLQ"
                  [alwaysShowText]="true"
                  [buttonText]="'Clear DLQ'"
                  [primaryIcon]="'fa-solid fa-trash-can fa-xl'"></app-generic-button>
              </div>
              <div class="mb-2">
                <app-generic-button
                  (click)="shareDeadLetterQueue()"
                  description="Share DLQ"
                  [alwaysShowText]="true"
                  [buttonText]="'Share DLQ'"
                  [primaryIcon]="'fa-solid fa-share-from-square fa-xl'"></app-generic-button>
              </div>
            </div>
        </div>

        @if (!environment.production || environment.platform == 'web') {
            <div>
                <div class="h5">Developer tools</div>
                <div class="mb-2 card rounded-3 p-3">
                    <app-generic-button
                        (click)="routeToDeveloperConsole()"
                        description="Show developer tools"
                        [alwaysShowText]="true"
                        [buttonText]="'Show developer tools'"
                        [primaryIcon]="'fa-solid fa-wrench fa-xl'"/>

                </div>
             </div>
        }
      <div class="m-0 fw-bold">Nùmero do ERAS</div>
      <div class="d-flex justify-content-center mb-3">
        <input (input)="setMetadata($event, 'eras')"
               class="form-control border-0 fs-main height-50px inner-shadow rounded-2"
               type="search"
               value="{{ currentFarm()?.farmMetadata?.eras}}">
      </div>
      <div class="m-0 fw-bold">Nùmero do SIF</div>
      <div class="d-flex justify-content-center mb-3">
        <input (input)="setMetadata($event, 'sif')"
               class="form-control border-0 fs-main height-50px inner-shadow rounded-2"
               type="search"
               value="{{ currentFarm()?.farmMetadata?.sif}}">
      </div>
      <div class="mb-3">
        <app-generic-button
          (click)="applyChanges()"
          description="Apply changes"
          [alwaysShowText]="true"
          [buttonText]="'Apply changes'"
          [disabled]="!metadataHasChanged()"
          [primaryIcon]="'fa-solid fa-check fa-2x'"/>
      </div>
    </div>
</div>
